import { render, staticRenderFns } from "./SendHttpRequest.vue?vue&type=template&id=98f2aea6"
import script from "./SendHttpRequest.vue?vue&type=script&lang=js"
export * from "./SendHttpRequest.vue?vue&type=script&lang=js"
import style0 from "./SendHttpRequest.vue?vue&type=style&index=0&id=98f2aea6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports